import React from 'react'
import { Chip } from '@mui/material'
import TimelineLane from './TimelineLane'

const CHIP_COLOR = { info: 'info', error: 'error', default: 'default' }

// The part of the correction that one lane draws: the band if the lane is one the stretch covers (RN41) and, in the clock-ins
// of the worker, the handles (RN40). A lane that has nothing to draw gets `undefined`, so it is never painted again for it.
const overlayOf = (lane, overlay) => {
  if (!overlay) return undefined
  const band = overlay.bandLaneKeys.includes(lane.key) ? overlay.band : undefined
  const handles = lane.kind === 'imputations' && lane.workerId === overlay.workerId ? overlay.handles : undefined
  return band || handles ? { band, handles } : undefined
}

// A block of the timeline: a header row (title, subtitle and chips) and the lanes of one machine, or of one worker on one
// machine (maqueta `.grp`). Memoised: it only paints again when its model, the scale or ITS part of the selection change.
// `selection` and `overlay` are only given to the block that has the selected intervention; the others keep receiving `undefined`.
const TimelineBlock = ({ block, fromMs, pxPerMs, trackWidth, selection, overlay, onDrag, onNudge }) => (
  <div data-block={block.key}>
    <div className='dc-row dc-group'>
      <div className='dc-cell-l'>
        <b>{block.title}</b>
        <span>{block.subtitle}</span>
      </div>
      <div className='dc-track' style={{ width: trackWidth }}>
        <span className='dc-chips'>
          {block.chips.map((chip) => <Chip key={chip.key} size='small' color={CHIP_COLOR[chip.tone] || 'default'} label={chip.label} />)}
        </span>
      </div>
    </div>
    {block.lanes.map((lane, index) => (
      <TimelineLane
        key={lane.key}
        blockKey={block.key}
        lane={lane}
        fromMs={fromMs}
        pxPerMs={pxPerMs}
        trackWidth={trackWidth}
        alternate={index % 2 === 1}
        highlightedRowIds={selection && selection.laneKind === lane.kind && selection.workerId === lane.workerId ? selection.rowIds : undefined}
        overlay={overlayOf(lane, overlay)}
        onDrag={onDrag}
        onNudge={onNudge}
      />
    ))}
  </div>
)

export default React.memo(TimelineBlock)
